import request from '@/utils/request'

export function Login(data) {
  return request({
    url: 'api/Token/Login',
    method: 'post',
    data
  })
}

export function GetSelfInfo() {
  return request({
    url: 'api/Token/GetSelfInfo',
    method: 'get',
  })
}


export function getUserInfo() {
  return request({
    url: 'api/user/get',
    method: 'get'
  })
}

export function SetSceneStr() {
  return request({
    url: 'api/Token/SetSceneStr',
    method: 'get'
  })
}

export function GetQrcode(data) {
  return request({
    url: 'api/Token/GetQrcode',
    method: 'get',
    params:data
  })
}

export function GetSceneStr(data) {
  return request({
    url: 'api/Token/GetSceneStr',
    method: 'get',
    params:data
  })
}


